import React, { Component } from "react";
import { PropTypes } from "prop-types";
import PlacementSelector from "@zendesk/knowledge-components/lib/PlacementSelector";
import ModalDialog from "@zendesk/knowledge-components/lib/ModalDialog";
import t from "@zendesk/client-i18n-tools";
import { Mutation } from "react-apollo";
import { addFilterMutation } from "mutations/addFilterMutation";
import toGlobalId from "@zendesk/knowledge-utils/lib/toGlobalId";

import styles from "./PlacementSelectorModal.css";

export default class PlacementFilterModal extends Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedOption: {},
    };
  }

  onOptionClick = option => {
    this.setState({ selectedOption: option });
  };

  render() {
    const { onClose } = this.props;
    const { selectedOption } = this.state;

    return (
      <Mutation mutation={addFilterMutation}>
        {mutate => (
          <ModalDialog
            id="placementSelectorModal"
            title={t("knowledge-verification.placement")}
            testId="placementSelectorModal"
            body={
              <div className={styles.body}>
                <p className={styles.description}>
                  {t("knowledge-verification.selectCategoryOrSection")}
                </p>
                <PlacementSelector onOptionSelect={this.onOptionClick} />
              </div>
            }
            onSubmit={() => {
              onClose();

              mutate({
                variables: {
                  type: selectedOption.type.toLowerCase(),
                  value: toGlobalId(selectedOption.type, selectedOption.id),
                },
              });
            }}
            onCancel={onClose}
            submitDisabled={!selectedOption.id}
            visible
          />
        )}
      </Mutation>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FilterMenu/PlacementSelectorModal.js